import React from 'react';
import { Image } from 'semantic-ui-react';
import defaultAgeReadyLogo from '../../logo.png';
import 'semantic-ui-css/semantic.min.css';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { observer } from 'mobx-react-lite';
import styles from './PartnerComponent.module.css'

const PartnerLogoComponent: React.FC = () => {
  const { caregiverStore, partnerStore } = useAgeReadyContext();

  const getLogoByPartnerId = (partnerId: string | undefined | null): string | undefined => {
    if (!partnerId) {
      return undefined;
    }
    return partnerStore.logosByPartnerId.get(partnerId);
  };

  return (
    <>
      {!!getLogoByPartnerId(caregiverStore.partnerCode) && (
        <Image
          src={getLogoByPartnerId(caregiverStore.partnerCode)}
          alt='age-ready-logo'
          id={styles['header-logo']}
        />
      )}
      {!getLogoByPartnerId(caregiverStore.partnerCode) && (
        <>
          <Image
            src={defaultAgeReadyLogo}
            alt='age-ready-logo'
            id={styles['header-logo']}
          />
        </>
      )}
    </>
  );
};

export default observer(PartnerLogoComponent);
